export default "__VITE_ASSET__DPJNLo3N__"